export var TroubleshootingLabel;
(function (TroubleshootingLabel) {
    TroubleshootingLabel["VISITOR_SEND_HIT"] = "VISITOR_SEND_HIT";
    TroubleshootingLabel["VISITOR_FETCH_CAMPAIGNS_ERROR"] = "VISITOR_FETCH_CAMPAIGNS_ERROR";
    TroubleshootingLabel["VISITOR_FETCH_CAMPAIGNS"] = "VISITOR_FETCH_CAMPAIGNS";
    TroubleshootingLabel["VISITOR_AUTHENTICATE"] = "VISITOR_AUTHENTICATE";
    TroubleshootingLabel["VISITOR_UNAUTHENTICATE"] = "VISITOR_UNAUTHENTICATE";
    TroubleshootingLabel["VISITOR_EXPOSED_FLAG_NOT_FOUND"] = "VISITOR_EXPOSED_FLAG_NOT_FOUND";
    TroubleshootingLabel["FLAG_VALUE_NOT_CALLED"] = "FLAG_VALUE_NOT_CALLED";
    TroubleshootingLabel["GET_FLAG_VALUE_FLAG_NOT_FOUND"] = "GET_FLAG_VALUE_FLAG_NOT_FOUND";
    TroubleshootingLabel["GET_FLAG_METADATA_TYPE_WARNING"] = "GET_FLAG_METADATA_TYPE_WARNING";
    TroubleshootingLabel["GET_FLAG_VALUE_TYPE_WARNING"] = "GET_FLAG_VALUE_TYPE_WARNING";
    TroubleshootingLabel["VISITOR_EXPOSED_TYPE_WARNING"] = "VISITOR_EXPOSED_TYPE_WARNING";
    TroubleshootingLabel["VISITOR_SEND_ACTIVATE"] = "VISITOR_SEND_ACTIVATE";
    TroubleshootingLabel["GET_CAMPAIGNS_ROUTE_RESPONSE_ERROR"] = "GET_CAMPAIGNS_ROUTE_RESPONSE_ERROR";
    TroubleshootingLabel["GET_CAMPAIGNS_ROUTE_RESPONSE"] = "GET_CAMPAIGNS_ROUTE_RESPONSE";
    TroubleshootingLabel["SDK_BUCKETING_FILE"] = "SDK_BUCKETING_FILE";
    TroubleshootingLabel["SEND_ACTIVATE_HIT_ROUTE_ERROR"] = "SEND_ACTIVATE_HIT_ROUTE_ERROR";
    TroubleshootingLabel["SEND_BATCH_HIT_ROUTE_RESPONSE_ERROR"] = "SEND_BATCH_HIT_ROUTE_RESPONSE_ERROR";
    TroubleshootingLabel["SEND_HIT_ROUTE_ERROR"] = "SEND_HIT_ROUTE_ERROR";
    TroubleshootingLabel["SDK_BUCKETING_FILE_ERROR"] = "SDK_BUCKETING_FILE_ERROR";
    TroubleshootingLabel["SDK_CONFIG"] = "SDK_CONFIG";
    TroubleshootingLabel["ACCOUNT_SETTINGS"] = "ACCOUNT_SETTINGS";
    TroubleshootingLabel["ACCOUNT_SETTINGS_ERROR"] = "ACCOUNT_SETTINGS_ERROR";
    TroubleshootingLabel["EMOTION_AI_SCORE"] = "EMOTION_EAI_SCORE";
    TroubleshootingLabel["EMOTION_AI_SCORE_FROM_LOCAL_CACHE"] = "EMOTION_AI_SCORE_FROM_LOCAL_CACHE";
    TroubleshootingLabel["EMOTION_AI_SCORE_ERROR"] = "EMOTION_EAI_SCORE_ERROR";
    TroubleshootingLabel["EMOTION_AI_VISITOR_EVENT"] = "EMOTION_AI_VISITOR_EVENT";
    TroubleshootingLabel["EMOTION_AI_VISITOR_EVENT_ERROR"] = "EMOTION_AI_VISITOR_EVENT_ERROR";
    TroubleshootingLabel["EMOTION_AI_PAGE_VIEW"] = "EMOTION_AI_PAGE_VIEW";
    TroubleshootingLabel["EMOTION_AI_PAGE_VIEW_ERROR"] = "EMOTION_AI_PAGE_VIEW_ERROR";
    TroubleshootingLabel["EMOTION_AI_START_COLLECTING"] = "EMOTION_AI_START_COLLECTING";
    TroubleshootingLabel["EMOTION_AI_STOP_COLLECTING"] = "EMOTION_AI_STOP_COLLECTING";
    TroubleshootingLabel["EMOTION_AI_START_SCORING"] = "EMOTION_AI_START_SCORING";
    TroubleshootingLabel["EMOTION_AI_SCORING_FAILED"] = "EMOTION_AI_SCORING_FAILED";
    TroubleshootingLabel["EMOTION_AI_SCORING_SUCCESS"] = "EMOTION_AI_SCORING_SUCCESS";
})(TroubleshootingLabel || (TroubleshootingLabel = {}));
export var VisitorCacheStatus;
(function (VisitorCacheStatus) {
    VisitorCacheStatus["NONE"] = "NONE";
    VisitorCacheStatus["ANONYMOUS_ID_CACHE"] = "ANONYMOUS_ID_CACHE";
    VisitorCacheStatus["VISITOR_ID_CACHE"] = "VISITOR_ID_CACHE";
    VisitorCacheStatus["VISITOR_ID_CACHE_WITH_ANONYMOUS_ID_CACHE"] = "VISITOR_ID_CACHE_WITH_ANONYMOUS_ID_CACHE";
})(VisitorCacheStatus || (VisitorCacheStatus = {}));
export var TargetingOperator;
(function (TargetingOperator) {
    TargetingOperator["EQUALS"] = "EQUALS";
    TargetingOperator["NOT_EQUALS"] = "NOT_EQUALS";
    TargetingOperator["CONTAINS"] = "CONTAINS";
    TargetingOperator["NOT_CONTAINS"] = "NOT_CONTAINS";
    TargetingOperator["EXISTS"] = "EXISTS";
    TargetingOperator["NOT_EXISTS"] = "NOT_EXISTS";
    TargetingOperator["GREATER_THAN"] = "GREATER_THAN";
    TargetingOperator["LOWER_THAN"] = "LOWER_THAN";
    TargetingOperator["GREATER_THAN_OR_EQUALS"] = "GREATER_THAN_OR_EQUALS";
    TargetingOperator["LOWER_THAN_OR_EQUALS"] = "LOWER_THAN_OR_EQUALS";
    TargetingOperator["STARTS_WITH"] = "STARTS_WITH";
    TargetingOperator["ENDS_WITH"] = "ENDS_WITH";
})(TargetingOperator || (TargetingOperator = {}));
export var ABTastyWebSDKPostMessageType;
(function (ABTastyWebSDKPostMessageType) {
    ABTastyWebSDKPostMessageType["AB_TASTY_WEB_SDK_INITIALIZED"] = "AB_TASTY_WEB_SDK_INITIALIZED";
})(ABTastyWebSDKPostMessageType || (ABTastyWebSDKPostMessageType = {}));
